var exports = {
  "TQ": "Checkbox.module__checkboxWrapper___WkIzVz",
  "r9": "Checkbox.module__disabled___WkIzVz",
  "iD": "Checkbox.module__menuDisabled___WkIzVz",
  "kv": "Checkbox.module__checkbox___WkIzVz",
  "aP": "Checkbox.module__box___WkIzVz",
  "LI": "Checkbox.module__round___WkIzVz",
  "KD": "Checkbox.module__checked___WkIzVz",
  "NX": "Checkbox.module__checkedInverted___WkIzVz",
  "e_": "Checkbox.module__inverted___WkIzVz",
  "oE": "Checkbox.module__checkIcon___WkIzVz",
  "HN": "Checkbox.module__invertedIcon___WkIzVz",
  "Pf": "Checkbox.module__label___WkIzVz",
  "hJ": "Checkbox.module__labelInteractive___WkIzVz",
  "QK": "Checkbox.module__labelText___WkIzVz",
  "GR": "Checkbox.module__keyboardShortcut___WkIzVz",
  "RA": "Checkbox.module__keyboardShortcutKey___WkIzVz",
  "wf": "Checkbox.module__keyboardShortcutLabel___WkIzVz",
  "xB": "Checkbox.module__keyboardShortcutHint___WkIzVz",
  "wP": "Checkbox.module__keyboardShortcutPortal___WkIzVz",
  "nV": "Checkbox.module__labelFocusRing___WkIzVz",
  "P8": "Checkbox.module__menuChecked___WkIzVz",
  "fb": "Checkbox.module__checkboxIndicator___WkIzVz",
};

module.exports = exports;
